export default "__VITE_ASSET__BZob5CO6__"